import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const SectionTitleModal = styled("p")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  paddingTop: "24px",
}));
